import { Injectable } from '@angular/core';
import { BaseApi } from './_base-api';
import { PaymentMethodEntity, PaymentMethodUpdate } from '@models';
import { Observable } from 'rxjs';
import { APIHelper } from '@controladad/ng-base';

@Injectable({
  providedIn: 'root',
})
export class PaymentMethodApiService extends BaseApi<PaymentMethodEntity, never, PaymentMethodUpdate> {
  constructor() {
    super('/AdminPanel/PaymentMethod', {
      get: '/AdminPanel/GetPaymentMethods',
    });
  }

  // @ts-ignore
  override getAll(): Observable<PaymentMethodEntity[]> {
    return http$.get<PaymentMethodEntity[]>('/AdminPanel/GetPaymentMethods');
  }

  // @ts-ignore
  override update(data: PaymentMethodUpdate): Observable<any> {
    return http$.put('/AdminPanel/EditPaymentMethod', {
      paymentMethodId: data.paymentMethodId,
      fields: APIHelper.nestValues(data.fields)
    });
  }
}
